<template>
    <header class="scr-header">
        <button @click="openNavigation" class="btn-icon">
            <i class="icon-menu-thin"></i>
        </button>
        <span class="hd-brand">
            <i class="icon-dxc"></i>
        </span>
        <span class="hd-title">{{component}}</span>
        <span v-if="component === 'Schedule'" class="hd-subtitle">{{lengthOfVisit}}</span>
    </header>
</template>

<script>

import moment from "moment";
export default {
    name: "Header",
    data() {
        return {
            visit: this.$store.getters.visit
        };
    },
    props: {
        //This is the title displayed at the top of the page.
        component: String
    },
    methods: {
        openNavigation() {
            //Fired when the navigation panel is opened.
            this.$emit("navigation");
        }
    },
    computed: {
        visitStartDate() {
            return this.visit
                ? moment(this.visit.startTime, "YYYY-MM-DD HH:mm").format(
                      "DD"
                  ) +
                      " " +
                      moment(this.visit.startTime, "YYYY-MM-DD HH:mm").format(
                          "MMM"
                      )
                : "";
        },
        visitEndDate() {
            return this.visit
                ? moment(this.visit.endTime, "YYYY-MM-DD HH:mm").format("DD") +
                      " " +
                      moment(this.visit.endTime, "YYYY-MM-DD HH:mm").format(
                          "MMM"
                      )
                : "";
        },
        lengthOfVisit() {
            return this.visitStartDate === this.visitEndDate
                ? this.visitStartDate
                : this.visitStartDate + " – " + this.visitEndDate;
        }
    },
    created() {
        this.$store.watch(
            state => state.visit,
            () => {
                this.visit = this.$store.getters.visit;
            }
        );
    }
};
</script>

<style>
</style>
